// Top 100 most-used AWS Terraform resources based on industry standards
export const awsTop100Whitelist = [
  // Compute
  "aws_instance",
  "aws_autoscaling_group",
  "aws_launch_template",
  "aws_lambda_function",
  "aws_ecs_cluster",
  "aws_ecs_service",
  "aws_ecs_task_definition",
  "aws_eks_cluster",
  "aws_eks_node_group",
  "aws_elastic_beanstalk_application",
  "aws_elastic_beanstalk_environment",
  "aws_batch_compute_environment",
  "aws_batch_job_definition",
  "aws_batch_job_queue",

  // Storage
  "aws_s3_bucket",
  "aws_s3_bucket_policy",
  "aws_s3_bucket_public_access_block",
  "aws_s3_object",
  "aws_ebs_volume",
  "aws_ebs_snapshot",
  "aws_efs_file_system",
  "aws_efs_mount_target",
  "aws_fsx_windows_file_system",
  "aws_fsx_lustre_file_system",
  "aws_glacier_vault",

  // Database
  "aws_db_instance",
  "aws_db_subnet_group",
  "aws_db_parameter_group",
  "aws_rds_cluster",
  "aws_rds_cluster_instance",
  "aws_dynamodb_table",
  "aws_elasticache_cluster",
  "aws_elasticache_replication_group",
  "aws_redshift_cluster",
  "aws_neptune_cluster",
  "aws_docdb_cluster",
  "aws_docdb_cluster_instance",

  // Networking
  "aws_vpc",
  "aws_subnet",
  "aws_internet_gateway",
  "aws_nat_gateway",
  "aws_route_table",
  "aws_route_table_association",
  "aws_security_group",
  "aws_security_group_rule",
  "aws_network_acl",
  "aws_network_interface",
  "aws_eip",
  "aws_vpc_peering_connection",
  "aws_vpn_gateway",
  "aws_vpn_connection",
  "aws_customer_gateway",
  "aws_route53_zone",
  "aws_route53_record",
  "aws_cloudfront_distribution",
  "aws_elb",
  "aws_lb",
  "aws_lb_target_group",
  "aws_lb_listener",
  "aws_api_gateway_rest_api",
  "aws_api_gateway_resource",
  "aws_api_gateway_method",
  "aws_api_gateway_deployment",
  "aws_apigatewayv2_api",
  "aws_apigatewayv2_stage",
  "aws_direct_connect_gateway",
  "aws_vpc_endpoint",

  // Security
  "aws_iam_role",
  "aws_iam_role_policy",
  "aws_iam_policy",
  "aws_iam_policy_attachment",
  "aws_iam_user",
  "aws_iam_group",
  "aws_iam_access_key",
  "aws_kms_key",
  "aws_kms_alias",
  "aws_secretsmanager_secret",
  "aws_secretsmanager_secret_version",
  "aws_acm_certificate",
  "aws_cognito_user_pool",
  "aws_cognito_identity_pool",
  "aws_waf_web_acl",
  "aws_wafv2_web_acl",
  "aws_guardduty_detector",
  "aws_security_hub_account",

  // Analytics
  "aws_kinesis_stream",
  "aws_kinesis_firehose_delivery_stream",
  "aws_glue_catalog_database",
  "aws_glue_crawler",
  "aws_athena_database",
  "aws_athena_workgroup",
  "aws_emr_cluster",

  // DevOps
  "aws_codepipeline",
  "aws_codebuild_project",
  "aws_codecommit_repository",
  "aws_codedeploy_app",
  "aws_codedeploy_deployment_group",
  "aws_ecr_repository",

  // Monitoring
  "aws_cloudwatch_log_group",
  "aws_cloudwatch_log_stream",
  "aws_cloudwatch_metric_alarm",
  "aws_cloudwatch_dashboard",
  "aws_sns_topic",
  "aws_sns_topic_subscription",
  "aws_sqs_queue",
  "aws_cloudtrail",

  // AI/ML
  "aws_sagemaker_notebook_instance",
  "aws_sagemaker_model",
  "aws_sagemaker_endpoint",
  "aws_sagemaker_endpoint_configuration",

  // Other
  "aws_ssm_parameter",
  "aws_backup_vault",
  "aws_backup_plan",
  "aws_config_configuration_recorder",
  "aws_cloudformation_stack",
] as const;

export type AwsTop100Tf = (typeof awsTop100Whitelist)[number];
